import { FeatureFlagDeclarations } from '../feature-flags/feature-flag-declarations';
import { useEnablePickListHtmlEditor } from '../feature-flags/hooks/use-enable-pick-list-html-editor';
import { useFeatureFlag } from '../feature-flags/hooks/use-feature-flag';
import { usePickListTemplatesFeatureGate } from './use-pick-list-templates-feature-gate';

export const useIsPickListTemplateSelectionAvailable = (): boolean => {
  const isHtmlEditorEnabled = useEnablePickListHtmlEditor();
  const shouldSendV3QueueServiceDownloadUrl = useFeatureFlag(FeatureFlagDeclarations.shouldSendV3QueueServiceDownloadUrl);
  const { isFeatureEnabled } = usePickListTemplatesFeatureGate();

  return isHtmlEditorEnabled && shouldSendV3QueueServiceDownloadUrl && isFeatureEnabled;
};
